import randomColor from "randomcolor";
import { useNavigate, useParams } from "react-router";
import _ from "lodash";
import {
  Box,
  Center,
  HStack,
  isAdminViewer,
  isEsopViewer,
  VStack,
} from "../components/utils";
import { useGetChangeRequests, useGrants } from "../queries";
import { RequestType, usePendingRequests } from "../queries/pendingRequests";
import { useAuthorizationStore } from "../store";
import { useVestingApproveDialog } from "../store/useDialogStore";
import { calculateDateDiffTillNow } from "../utils/date";

function PendingRequests() {
  const { id } = useParams();
  const _id = id ?? "";
  const header = "Pending Requests";
  const { authority } = useAuthorizationStore();
  const message =
    "Vesting and Exercise Request(s) Pending Approval with Admin/Option Approver";
  let { data: requests } = usePendingRequests();

  if (_id !== "") {
    if (requests)
      requests = requests.filter((request) => request.planId === _id);
  }
  const { setState: setVestingApproveDialog } = useVestingApproveDialog();
  const isUserAdminViewer = isAdminViewer();
  const isUserEsopViewer = isEsopViewer();
  const navigate = useNavigate();
  function handleAction(
    type: RequestType,
    id: string,
    isDarwinBoxSyncPending?: boolean
  ) {
    if (isDarwinBoxSyncPending) {
      navigate("/options/pendingRequests");
    } else if (type === "Vest Request") {
      setVestingApproveDialog({
        open: true,
        optionHolderId: id,
      });
    } else if (type === "Exercise Request") {
      navigate(
        "/options/esopTransactions/exerciseRequests?activeTab=Exercise%20Requests"
      );
    }
  }

  const { data: changeRequests, isLoading } = useGetChangeRequests();

  const pendingChangeRequestsCount = (changeRequests ?? []).filter(
    (req) => req.status === "PENDING" || req.status === "REQUESTED"
  ).length;

  const displayRequests = [
    ...(pendingChangeRequestsCount > 0
      ? [
          {
            subject: `${pendingChangeRequestsCount} Employee data sync approvals`,
            type: "Darwin Box Sync" as RequestType,
            id: "darwin-box-sync-pending",
            requestDate:
              _.maxBy(changeRequests, (req) => new Date(req.updatedAt))
                ?.updatedAt || "",
            isDarwinBoxSyncPending: true,
          },
        ]
      : []),
    ...(requests ?? []),
  ];

  return (
    <Box className="p-6 overflow-auto bg-white border rounded-lg max-h-96 border-borderColor drop-shadow-box ">
      <VStack className="mb-4">
        <p className="font-medium text-gray-dark">{header}</p>
        <p className="text-xs1 font-semi-medium text-gray-light">{message}</p>
      </VStack>
      <Box className="overflow-auto max-h-72">
        {displayRequests?.map((row, _index) => {
          const backgroundColor = randomColor({
            luminosity: "dark",
            format: "rgba",
            alpha: 0.2,
            seed: row.subject,
          });
          return (
            <HStack
              key={`${row.subject}-${_index}`}
              className="items-center justify-between p-2"
            >
              <HStack>
                <Box
                  style={{ backgroundColor }}
                  className="w-4 h-4 mt-2 rounded"
                ></Box>
                <VStack className="w-5/6 pl-4 ">
                  <p
                    className={`font-medium cursor-pointer text-xs2 text-gray-dark ${
                      isUserAdminViewer || isUserEsopViewer
                        ? "cursor-not-allowed"
                        : ""
                    }`}
                    onClick={() =>
                      !(isUserAdminViewer || isUserEsopViewer)
                        ? handleAction(
                            row.type,
                            row.id || "",
                            (row as any).isDarwinBoxSyncPending
                          )
                        : null
                    }
                  >
                    {row.subject}
                  </p>
                  <p className="text-xs1 font-semi-medium text-gray-light">
                    {row.requestDate &&
                      calculateDateDiffTillNow(row.requestDate)}
                  </p>
                </VStack>
              </HStack>
              <button
                className={`h-4 ${
                  isUserAdminViewer || isUserEsopViewer
                    ? "cursor-not-allowed"
                    : ""
                }`}
                onClick={() =>
                  !(isUserAdminViewer || isUserEsopViewer)
                    ? handleAction(
                        row.type,
                        row.id ?? "",
                        (row as any).isDarwinBoxSyncPending
                      )
                    : null
                }
              ></button>
            </HStack>
          );
        })}
        {requests?.length === 0 && pendingChangeRequestsCount === 0 && (
          <Center className="h-48">
            <p className="p-4 font-medium text-teal-600 rounded">
              No Pending Requests !!{" "}
            </p>
          </Center>
        )}
      </Box>
    </Box>
  );
}

export default PendingRequests;
